import { sellerRequestDocument } from 'forms';
import { isEmpty } from 'ramda';
import { createAction } from 'redux-actions';

import { getCduUserLogon } from '@gef-ui/cdu-user/selectors';

import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';

import * as types from './actionTypes';
import { DOCUMENT_NOT_FOUND_DIALOG } from './constants';
import { getDocumentIds, getFiles } from './selectors';

export const addDocumentId = createAction(types.ADD_DOCUMENT_ID, (id) => ({ id }));
export const removeDocumentId = createAction(types.REMOVE_DOCUMENT_ID, (id) => ({ id }));
export const setFiles = createAction(types.SET_FILES, (files) => ({ files }));
export const setUploadErrors = createAction(types.SET_UPLOAD_ERRORS, (errors) => ({ errors }));
export const resetDocuments = createAction(types.RESET_DOCUMENTS, () => ({}));

export const submitDocumentId = () => (dispatch, getState) => {
	const { documentId } = sellerRequestDocument.selectors.getFormData(getState());
	if (!documentId || documentId.trim() === '') return;
	// user may type whole ID (with "D" character) - BE wants clean ID, so we are getting rid of it
	const cleanDocumentId = documentId.replace(/d/gi, '');

	dispatch(dialog.actions.close(DOCUMENT_NOT_FOUND_DIALOG));
	dispatch(
		fetch.actions.get(fetch.constants.urls.checkTaskAttachment, {
			queryParams: {
				documentId: cleanDocumentId,
			},
			onSuccess: [
				() => () => {
					dispatch(addDocumentId(documentId));
					dispatch(sellerRequestDocument.actions.toInitialState());
				},
			],
			onError: [
				() => () => {
					dispatch(dialog.actions.open(DOCUMENT_NOT_FOUND_DIALOG));
				},
			],
			shouldReportError: ({ failure }) => {
				return failure.status !== 404;
			},
		}),
	);
};

export const uploadFiles = (taskId) => async (dispatch, getState) => {
	const state = getState();
	const files = getFiles(state);
	const documentIds = getDocumentIds(state);
	const userLogin = getCduUserLogon(state);

	const body = {
		emails: [],
		taskId,
		notifyManagers: true,
		userLogin,
	};

	// check for documentIds
	// if documentIds exist > upload them as whole array
	// if no documentIds > skip and call email notif in the end
	if (!isEmpty(documentIds)) {
		const cleanedDocumentIds = documentIds.map((docId) => docId.replace(/d/gi, ''));
		await dispatch(
			fetch.actions.post(fetch.constants.urls.createTaskAttachment, {
				replaceParams: { id: taskId },
				body: {
					documentIds: cleanedDocumentIds,
				},
			}),
		);
	}

	// check for files
	// if files exist > upload them individualy > after all upload promises resolve > call email notif endpoint
	if (!isEmpty(files)) {
		const processedFiles = files.map((file) => {
			const formData = new FormData();
			formData.append('file', file);
			return formData;
		});

		const promises = processedFiles.map(async (file) => {
			await dispatch(
				fetch.actions.uploadData(fetch.constants.urls.createTaskAttachment, {
					replaceParams: { id: taskId },
					body: file,
				}),
			);
		});

		// after all promises of file upload are resolved, call email notif with body
		return Promise.all([...promises]).then(() => {
			dispatch(
				fetch.actions.post(fetch.constants.urls.taskEmailCopy, {
					body,
				}),
			);
		});
	}

	// call email notif everytime when task is created - even if no documentIds or file attachments
	dispatch(
		fetch.actions.post(fetch.constants.urls.taskEmailCopy, {
			body,
		}),
	);
};
